import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import GLightbox from 'glightbox';
import $ from "jquery";
require('readmore-js');
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

let lightbox = GLightbox({
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
});

let lightboxImageGroup = GLightbox({
    selector: '.gLightBoxImageGroup',
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
});

let lightboxImageGroupTransportation = GLightbox({
    selector: '.glightboxTransportation',
    touchNavigation: true,
    loop: true,
});

let lightboxImageGroupLand = GLightbox({
    selector: '.glightboxLand',
    touchNavigation: true,
    loop: true,
});

let lightboxImageGroupND = GLightbox({
    selector: '.glightboxND',
    touchNavigation: true,
    loop: true,
});

let lightboxImageGroupCZ = GLightbox({
    selector: '.glightboxCZ',
    touchNavigation: true,
    loop: true,
});

let lightboxImageHeroGroup = GLightbox({
    selector: '.gLightBoxImageHeroGroup',
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
})

let lightboxFlorPlan = GLightbox({
    selector: '.gLightBoxFloorPlan',
    touchNavigation: true,
    loop: false,
    autoplayVideos: true
});

let lightboxVideo = GLightbox({
    selector: '.gLightBoxVideo'
});

let lightboxImageGroupToolBox = GLightbox({
    selector: '.gLightBoxImageGroupToolBox',
    touchNavigation: true,
    loop: false,
    autoplayVideos: true
});

let lightboxImageGroupOnSiteInspection = GLightbox({
    selector: '.gLightBoxImageGroupOnSiteInspection',
    touchNavigation: true,
    loop: false,
    autoplayVideos: true
});

let gLightBoxDroneGroupOnSiteInspection = GLightbox({
    selector: '.gLightBoxDroneGroupOnSiteInspection',
    touchNavigation: true,
    loop: false,
    autoplayVideos: true
});

let lightboxFlorPlanToolBox = GLightbox({
    selector: '.gLightBoxFloorPlanToolBox',
    touchNavigation: true,
    loop: false,
    autoplayVideos: true
});

let lightboxVideoToolbox = GLightbox({
    selector: '.gLightBoxVideoToolbox'
});

let lightboxInlineIframe = GLightbox({
    selector: '.gLightBoxInlineIframe'
});

let glightboxSHPhoto0 = GLightbox({
    selector: '.glightboxSHPhoto0',
    touchNavigation: true,
    loop: true,
});
let glightboxSHFloor0 = GLightbox({
    selector: '.glightboxSHFloor0',
    touchNavigation: true,
    loop: true,
});
let glightboxSHPhoto1 = GLightbox({
    selector: '.glightboxSHPhoto1',
    touchNavigation: true,
    loop: true,
});
let glightboxSHFloor1 = GLightbox({
    selector: '.glightboxSHFloor1',
    touchNavigation: true,
    loop: true,
});
let glightboxSHPhoto2 = GLightbox({
    selector: '.glightboxSHPhoto2',
    touchNavigation: true,
    loop: true,
});
let glightboxSHFloor2 = GLightbox({
    selector: '.glightboxSHFloor2',
    touchNavigation: true,
    loop: true,
});
let glightboxSHPhoto3 = GLightbox({
    selector: '.glightboxSHPhoto3',
    touchNavigation: true,
    loop: true,
});
let glightboxSHFloor3 = GLightbox({
    selector: '.glightboxSHFloor3',
    touchNavigation: true,
    loop: true,
});
let glightboxSHPhoto4 = GLightbox({
    selector: '.glightboxSHPhoto4',
    touchNavigation: true,
    loop: true,
});
let glightboxSHFloor4 = GLightbox({
    selector: '.glightboxSHFloor4',
    touchNavigation: true,
    loop: true,
});
let glightboxSHPhoto5 = GLightbox({
    selector: '.glightboxSHPhoto5',
    touchNavigation: true,
    loop: true,
});
let glightboxSHFloor5 = GLightbox({
    selector: '.glightboxSHFloor5',
    touchNavigation: true,
    loop: true,
});
let glightboxSHPhoto6 = GLightbox({
    selector: '.glightboxSHPhoto6',
    touchNavigation: true,
    loop: true,
});
let glightboxSHFloor6 = GLightbox({
    selector: '.glightboxSHFloor6',
    touchNavigation: true,
    loop: true,
});
let glightboxSHPhoto7 = GLightbox({
    selector: '.glightboxSHPhoto7',
    touchNavigation: true,
    loop: true,
});
let glightboxSHFloor7 = GLightbox({
    selector: '.glightboxSHFloor7',
    touchNavigation: true,
    loop: true,
});
let glightboxSHPhoto8 = GLightbox({
    selector: '.glightboxSHPhoto8',
    touchNavigation: true,
    loop: true,
});
let glightboxSHFloor8 = GLightbox({
    selector: '.glightboxSHFloor8',
    touchNavigation: true,
    loop: true,
});
let glightboxSHPhoto9 = GLightbox({
    selector: '.glightboxSHPhoto9',
    touchNavigation: true,
    loop: true,
});
let glightboxSHFloor9 = GLightbox({
    selector: '.glightboxSHFloor9',
    touchNavigation: true,
    loop: true,
});

const cardProperties = document.querySelectorAll('.card-property');
cardProperties.forEach((card, index) => {
    let gLightBoxPropertyCompare = GLightbox({
        selector: `.gLightBoxPropertyCompare${index}`
    });
});

// transportation map
var map;
var property_location;
var geocoder;
var directionsService;
var directionsRenderer;

$('#whereTo').on('input', debounce(function(){
    var whereUrl = $('#whereUrl').val();
    var whereLat = $('#whereLat').val();
    var whereLong = $('#whereLong').val();
    var whereType = $('#whereType').val();
    let data = $(this).val()
    
    jQuery.ajax({
        type: "post",
        url: `${whereUrl}/wp-admin/admin-ajax.php`,
        dataType : "json",
        data: {action: "search_transport", keyword: data, lat: whereLat, long: whereLong, type: whereType},
        complete: function (response) {
            if(response.responseJSON.trigger == 'yes'){
                if(response.responseJSON.map.length > 0){
                    $('.transportation__result').css('display','block');
                    var _html = '<ul>';
                    response.responseJSON.map.map((items, index) => {
                        _html += '<li class="transportationMapItems" data-id="'+items.place_id+'"><p>'+items.location+'</p><span>'+items.details+'</span></li>';
                    })
                    _html += '</ul>';
                    $('.transportation__result').html(_html);

                    $('.transportation__map').css('display','block');
                    initMap()
                }
            }
        },
    });
},1000));

$(document).on('click', '.transportationMapItems', function() {
    var place_id = $(this).attr("data-id");

    $('.transportation__result').css('display','none');
    $('#wherePlace').val(place_id)
    getLocationOfDestination(place_id)
})

$('.transportationItems').on('click', function (e) {
    var type = $(this).attr("data-type");
    $('#whereType').val(type);

    // $('.transportation_estimate').html('')
    getLocationOfDestination($('#wherePlace').val())
})

function getLocationOfDestination(placeId){
    geocoder = new google.maps.Geocoder();
    geocoder.geocode({ placeId: placeId })
    .then(({ results }) => {
        if (results[0]) {
            calcRoute(results[0].geometry.location.lat(), results[0].geometry.location.lng());
        } else {
            window.alert("No results found");
        }
    }).catch((e) => window.alert("Geocoder failed due to: " + e));
}

function calcRoute(lat, long) {
    var destination_location = new google.maps.LatLng(lat, long);
    var selected_mode = $('#whereType').val();
    var request = {
        origin: property_location,
        destination: destination_location,
        travelMode: google.maps.TravelMode[selected_mode],
        avoidTolls: true,
        drivingOptions: {
            departureTime: new Date(Date.now() + 10000),
            trafficModel: 'bestguess'
        }
    };
    directionsService.route(request, function(response, status) {
        if (status == 'OK') {
            console.log(response);
            directionsRenderer.setDirections(response);
            var time = 0;
            if(selected_mode == 'DRIVING'){
                time = response.routes[0].legs[0].duration_in_traffic.value / 60
            } else {
                time = response.routes[0].legs[0].duration.value / 60
            }
            var new_time = "";
            if(time < 60){
                new_time = time.toFixed(0)+" mins";
            }else{
                var hours = Math.floor(time / 60);
                var minutes = time % 60;
                new_time = hours+" hrs "+ minutes.toFixed(0)+" mins";
            }
            // console.log(new_time);

            var _by = "";
            $('.result-time').html('');
            if(selected_mode == 'DRIVING'){
                _by = 'Driving route';
                $('.for-driving').html(new_time)
            }
            if(selected_mode == 'BICYCLING'){
                _by = 'Bicycling route'
                $('.for-bicycling').html(new_time)
            }
            if(selected_mode == 'TRANSIT'){
                _by = 'Public transit route'
                $('.for-transit').html(new_time)
            }
            if(selected_mode == 'WALKING'){
                _by = 'Sidewalks route'
                $('.for-walking').html(new_time)
            }

            // $('.transportation_estimate').html('Estimated by '+_by+' '+new_time)

        }
    });
}

function initMap() {
    directionsService = new google.maps.DirectionsService();
    directionsRenderer = new google.maps.DirectionsRenderer();
    geocoder = new google.maps.Geocoder();
    property_location = new google.maps.LatLng($('#whereLat').val(), $('#whereLong').val());

    var mapOptions = {
        zoom: 14,
        center: property_location,
        disableDefaultUI: true,
        fullscreenControl: true,
        zoomControl: true,
    }

    var map = new google.maps.Map(document.getElementById('transportation__map'), mapOptions);
    new google.maps.Marker({
        position: property_location, 
        map: map, 
        icon:  {
            // url: "{{asset(env('URL_IMAGE').'marker/navigate.png')}}", // url
            scaledSize: new google.maps.Size(50, 50), // scaled size
        }, 
        draggable: false,
    });
    directionsRenderer.setMap(map);
}

// transportation map

function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

// statistics
$(document).on('click', '.statistic-download', function() {
    var report_id = $(this).attr("data-id");
    var myAjaxUrl = $(this).attr("data-myAjaxUrl");
    
    jQuery.ajax({
        type: "post",
        url: `${myAjaxUrl}/wp-admin/admin-ajax.php`,
        dataType : "json",
        data: {action: "download_statistic", myReportId: report_id},
        complete: function (response) {
            let fileName = 'statistic_'+report_id;
            if(response.responseJSON.status){
                var $a = $("<a>");
                $a.attr("href",response.responseJSON.file);
                $("body").append($a);
                $a.attr("download",fileName+".xls");
                $a[0].click();
                $a.remove();
            }
        },
    });
})

$('.saveReportToAccount').on('click', function (e) {
    // var myReportId = $('#myReportId').val();
    // var myUserId = $('#myUserId').val();
    // var myAjaxUrl = $('#myAjaxUrl').val();
    
    // jQuery.ajax({
    //     type: "post",
    //     url: `${myAjaxUrl}/wp-admin/admin-ajax.php`,
    //     dataType : "json",
    //     data: {action: "save_report_to_account", myReportId: myReportId, myUserId: myUserId},
    //     complete: function (response) {
            
    //     },
    // });

    // $('.saveReportToAccount').html('Report Saved')
})
$('.deleteReportToAccount').on('click', function (e) {
    var myReportId = $(this).attr("data-myReportId");
    var myUserId = $(this).attr("data-myUserId");
    var myAjaxUrl = $(this).attr("data-myAjaxUrl");
    
    jQuery.ajax({
        type: "post",
        url: `${myAjaxUrl}/wp-admin/admin-ajax.php`,
        dataType : "json",
        data: {action: "delete_report_to_account", myReportId: myReportId, myUserId: myUserId},
        complete: function (response) {
            // console.log('aaa',response)
            location.reload();
        },
    });
})

$('#shareReport').on('click', function (e) {
    $('.modale-share').addClass('opened')
    $('.copysharelinktext').html('Copy Link')
})
$('.btn-close-share').on('click', function (e) {
    $('.modale-share').removeClass('opened')
})
$('#copysharelink').on('click', function (e) {
    var myurl = window.location.href;
    myurl = myurl.replace('my-account/detail-report/','')
    navigator.clipboard.writeText(myurl)
    $('.copysharelinktext').html('Link copied')
})

if (document.querySelector('.req-sold-price') !== null) {
    $('.hide-for-reqsoldprice').hide();
    
    var rspName = $('#h-rsp-name').val();
    var rspEmail = $('#h-rsp-email').val();
    var rspPhone = $('#h-rsp-phone').val();

    $('#display-name-rsp').val(rspName);
    $('#email-rsp').val(rspEmail);
    $('#phone-rsp').val(rspPhone);
}

var swiper = new Swiper(".mySwiper", {
    loop: true,
    spaceBetween: 5,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
    direction: "vertical",

});
var swiper2 = new Swiper(".mySwiper2", {
    loop: true,
    spaceBetween: 10,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    thumbs: {
        swiper: swiper,
    },
});

var cardPropertySlider = new Swiper(".card-property-slider", {
    slidesPerView:1,
    loop: true,
    spaceBetween: 10,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

window.addEventListener("load", (event) => {
    $("#panel-nearby").css('display','block')
})

$('#paneltab1').click(function(){
    $(".tab-panel").css('display','none')
    $("#panel-nearby").css('display','block')
    $('.tab-header-panel').removeClass('active')
    $('#paneltab1').addClass('active')
});
$('#paneltab2').click(function(){
    $(".tab-panel").css('display','none')
    $("#panel-comperable").css('display','block')
    $('.tab-header-panel').removeClass('active')
    $('#paneltab2').addClass('active')
});
$('#paneltab3').click(function(){
    $(".tab-panel").css('display','none')
    $("#panel-explore").css('display','block')
    $('.tab-header-panel').removeClass('active')
    $('#paneltab3').addClass('active')
});

// scroll event
var rootElement = document.documentElement;
var amountScrolled = 700;
var scrollToOpenMenu = document.querySelector("#fab-menu");

function handleScrollOpenMenu() {
    if(scrollToOpenMenu){
        // Do something on scroll
        if (rootElement.scrollTop > amountScrolled) {
            // Show button
            scrollToOpenMenu.classList.add("show");
        } else {
            // Hide button
            scrollToOpenMenu.classList.remove("show");
            $('#toggle').prop( "checked", false );
        }
    }
}

document.addEventListener("scroll", handleScrollOpenMenu);

$(document).on('click', function (e) {
    if ($('#toggle').is(':checked')) {
        if ($(e.target).closest(".container-fab").length === 0) {
            $('#toggle').prop( "checked", false );
        }
    }
});

$('.nav-close').on('click', function (e) {
    $('#toggle').prop( "checked", false );
})

let reportMenuLinks = document.querySelectorAll('.report-menu__link');
reportMenuLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
        e.preventDefault();
        let dataLinkValue = link.getAttribute('data-link');
        let scrollTarget=document.getElementById(dataLinkValue);
        
        gsap.to(window, {
            duration: 0.1, 
            scrollTo: {
                y: scrollTarget,
                offsetY: 90 // offset from the top of the section
            }
        });
    });
});

$('.property-detail__map-container').on('click', function() {
    $('.modale-map').addClass('opened')
})

$('.btn-map-fullscreen').on('click', function() {
    $('.modale-map').addClass('opened')
})
$('.btn-close-map-fullscreen').on('click', function() {
    $('.modale-map').removeClass('opened')
})

$('.mapitem1').on('click', function() {
    $('.mapitem').removeClass('active')
    $('.mymapitem').removeClass('active')

    $(this).addClass('active')
    $('.mymapitem1').addClass('active')
})
$('.mapitem2').on('click', function() {
    $('.mapitem').removeClass('active')
    $('.mymapitem').removeClass('active')

    $(this).addClass('active')
    $('.mymapitem2').addClass('active')
})
$('.mapitem3').on('click', function() {
    $('.mapitem').removeClass('active')
    $('.mymapitem').removeClass('active')

    $(this).addClass('active')
    $('.mymapitem3').addClass('active')
})

$('.card-benefit__content').readmore({
    speed: 200,
    collapsedHeight: 100,
    moreLink: '<button class="btn-show-more">Read more</button>',
    lessLink: '<button class="btn-show-less">Read less</button>',
});

$('.click-service').on('click', function() {
    var id = $(this).attr("data-id");

    $('html, body').animate({
        scrollTop: $("#"+id).offset().top - 50
    }, 500);
})

// service faq
var btnFaqFirst = document.getElementById('faq-first');
var btnFaqSecond = document.getElementById('faq-second');
if(btnFaqFirst){
    btnFaqFirst.onclick = function(event)
    {
        event.preventDefault();
        var hideFaq = document.getElementsByClassName('hideFaq');
        for (var i = 0; i < hideFaq.length; ++i) {
            var item = hideFaq[i];  
            item.style.display = 'block';
        }

        btnFaqFirst.style.display = 'none';
        btnFaqSecond.style.display = 'block';
    }

}


window.addEventListener("load", (event) => {
    if (window.innerWidth >=768 ) {
        linkMoreDesktop()
    }else{
        linkMoreMobile()
    }
});

window.addEventListener("resize", function(){
    if (window.innerWidth >=768 ) {
        linkMoreDesktop()
    }else{
        linkMoreMobile()
    }
});

function linkMoreMobile(){
    $('.card-inclusions__content').readmore({
        speed: 200,
        collapsedHeight: 250,
        moreLink: '<button class="btn-show-more" href="#">Expand</button>',
        lessLink: '<button class="btn-show-less" href="#">Collapse</button>',
    });
}

function linkMoreDesktop(){
    let linkMoreElements = document.querySelectorAll('.card-inclusions__link-more');
    linkMoreElements.forEach(function(linkMore) {
        linkMore.addEventListener('click', function(event) {
            event.preventDefault();
            let contentElements=document.querySelectorAll('.card-inclusions__content');
            contentElements.forEach(function(contentElement) {
                if (contentElement.style.maxHeight) {
                    contentElement.style.maxHeight = null; 
                    linkMoreElements.forEach(function(linkMore) {
                        linkMore.innerHTML='Expand'
                    })
                } else {
                    contentElement.style.maxHeight = contentElement.scrollHeight + "px";
                    linkMoreElements.forEach(function(linkMore) {
                        linkMore.innerHTML='Collapse'
                    })
                }
            })
        });
    });
}
// document.getElementById("file").addEventListener("change", submitForm);

// function submitForm() {
//     var fcnt = $('#filecount').val();
//     var fname = $('#filename').val();
//     var imgclean = $('#file');
//     if(fcnt<=5)
//     {
//         data = new FormData();
//         data.append('file', $('#file')[0].files[0]);

//         var imgname  =  $('input[type=file]').val();
//             var size  =  $('#file')[0].files[0].size;

//             var ext =  imgname.substr( (imgname.lastIndexOf('.') +1) );
//             if(ext=='jpg' || ext=='jpeg' || ext=='png' || ext=='gif' || ext=='PNG' || ext=='JPG' || ext=='JPEG')
//             {
//                 if(size<=1000000)
//                 {
//                     $.ajax({
//                     url: "<?php echo base_url() ?>/upload.php",
//                     type: "POST",
//                     data: data,
//                     enctype: 'multipart/form-data',
//                     processData: false,  // tell jQuery not to process the data
//                     contentType: false   // tell jQuery not to set contentType
//                     }).done(function(data) {
//                     if(data!='FILE_SIZE_ERROR' || data!='FILE_TYPE_ERROR' )
//                     {
//                         fcnt = parseInt(fcnt)+1;
//                         $('#filecount').val(fcnt);
//                         var img = '<div class="dialog" id ="img_'+fcnt+'" ><img src="<?php echo base_url() ?>/local_cdn/'+data+'"><a href="#" id="rmv_'+fcnt+'" onclick="return removeit('+fcnt+')" class="close-classic"></a></div><input type="hidden" id="name_'+fcnt+'" value="'+data+'">';
//                         $('#prv').append(img);
//                         if(fname!=='')
//                         {
//                         fname = fname+','+data;
//                         }else
//                         {
//                         fname = data;
//                         }
//                         $('#filename').val(fname);
//                         imgclean.replaceWith( imgclean = imgclean.clone( true ) );
//                     }
//                     else
//                     {
//                         imgclean.replaceWith( imgclean = imgclean.clone( true ) );
//                         alert('SORRY SIZE AND TYPE ISSUE');
//                     }

//                     });
//                     return false;
//                 }//end size
//                 else
//                 {
//                     imgclean.replaceWith( imgclean = imgclean.clone( true ) );//Its for reset the value of file type
//                     alert('Sorry File size exceeding from 1 Mb');
//                 }
//             }//end FILETYPE
//             else
//             {
//                 imgclean.replaceWith( imgclean = imgclean.clone( true ) );
//                 alert('Sorry Only you can uplaod JPEG|JPG|PNG|GIF file type ');
//             }
//     }//end filecount
//     else
//     {    
//         imgclean.replaceWith( imgclean = imgclean.clone( true ) );
//         alert('You Can not Upload more than 6 Photos');
//     }
// }